import { _ as _hashClear } from "./auth-service-tools1340.js";
import { _ as _hashDelete } from "./auth-service-tools1341.js";
import { _ as _hashGet } from "./auth-service-tools1342.js";
import { _ as _hashHas } from "./auth-service-tools1343.js";
import { _ as _hashSet } from "./auth-service-tools1344.js";
var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
var _Hash = Hash;
export { _Hash as _ };